import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import * as Roles from "../../Models/Security/Roles";
import { ModalUtils } from '@singularsystems/neo-core';
import InternalApproverLookup from '../../Models/Approvals/Lookups/InternalApproverLookup';
import InternalApproversVM from './InternalApproversVM';
import InternalApproversEditModal from './Components/InternalApproversEditModal';

@observer
export default class InternalApproversView extends Views.ViewBase<InternalApproversVM> {

    constructor(props: unknown) {
        super("Internal Approvers", InternalApproversVM, props);
    }

    public render() {
        const canEdit = this.viewModel.authorisationService.hasRole(Roles.InternalApprover.Edit);
        const canDelete = this.viewModel.authorisationService.hasRole(Roles.InternalApprover.Delete);

        return (
            <div>
                <Neo.Card title="Criteria">
                    <div className="row">
                        <Neo.FormGroupInline bind={this.viewModel.criteria.meta.firstName} className="col-lg-3" />
                        <Neo.FormGroupInline bind={this.viewModel.criteria.meta.lastName} className="col-lg-3" />
                    </div>
                </Neo.Card>
                <Neo.Card title="Internal Approvers">
                    <Neo.Pager pageManager={this.viewModel.pageManager} pageControls="bottom" >
                        <NeoGrid.Grid<InternalApproverLookup> addButton={{ onClick: () => this.viewModel.editInternalApprover(null) }}>
                            {(item, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={meta.firstName} />
                                    <NeoGrid.Column display={meta.lastName} />
                                    <NeoGrid.Column display={meta.emailAddress} />
                                    <NeoGrid.Column display={meta.phoneNo} />
                                    <NeoGrid.ButtonColumn
                                        editButton={{ onClick: () => this.viewModel.editInternalApprover(item.internalApproverId), disabled: !canEdit }}
                                        deleteButton={{ onClick: () => ModalUtils.showYesNoDismissible("Delete", `Are you sure you want to delete ${item}?`, 
                                            () => this.viewModel.deleteInternalApprover(item.internalApproverId)) , disabled: !canDelete }} />
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </Neo.Pager>
                </Neo.Card>
                <InternalApproversEditModal viewModel={this.viewModel}/>
            </div>
        );
    }
}